module.exports = __webpack_public_path__ + "static/media/Prayer.bf8c856c.jpg";